import type {
  QuotationInvoiceDocumentItemDTO,
  QuotationInvoiceDocumentPaymentDTO,
  QuotationInvoiceDocumentListItem,
} from "@/modules/quotation-invoice/domain/types";
import { buildReceiptPaymentRecord } from "../lib/document-pdf-model";
import { QuotationInvoiceDocumentBody } from "./QuotationInvoiceDocumentBody";

export { buildReceiptPaymentRecord } from "../lib/document-pdf-model";

interface DocumentPdfPreviewContentProps {
  document: QuotationInvoiceDocumentListItem;
  items: QuotationInvoiceDocumentItemDTO[];
  payments?: QuotationInvoiceDocumentPaymentDTO[];
}

/** Screen + print — same layout as the document card on the detail page. */
export function DocumentPdfPreviewContent({
  document: doc,
  items,
  payments = [],
}: DocumentPdfPreviewContentProps) {
  const paymentRecord = buildReceiptPaymentRecord(doc, payments);

  return (
    <div
      id="document-pdf-content"
      className="mx-auto max-w-4xl print:max-w-none"
    >
      <QuotationInvoiceDocumentBody
        document={doc}
        items={items}
        paymentRecord={paymentRecord}
      />
    </div>
  );
}
